/**
 * splits a user-entered dropdown / multi-select options string into the
 * list of distinct option labels. Accepts both newline- and comma-separated
 * input, trims whitespace, and drops blanks.
 */
export function parseOptionsInput(raw: string | null | undefined): string[] {
  if (!raw) {
    return [];
  }

  return raw
    .split(/[\n,]/)
    .map((option) => option.trim())
    .filter((option) => option.length > 0);
}
